import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem } from '@mui/material';
import { useContext, useEffect, useMemo, useState } from 'react';
import './style.scss';
import { UserContext } from '../../../../context/UserContext';
import ReportsService from '../../../../../services/ReportsService';
import AdminService from '../../../../../services/AdminService';

export default function Reports() {
    const [users, setUsers] = useState([]);
    const [loadingUsers, setLoadingUsers] = useState(false);
    const [open, setOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const reportsService = useMemo(() => new ReportsService(), []);
    const adminService = useMemo(() => new AdminService(), []);
    const { user } = useContext(UserContext);

    async function loadUsers() {
        if (loadingUsers) {
            return;
        }
        setLoadingUsers(true);
        setTimeout(async () => {
            const response = await adminService.getUsers(user._id);
            setUsers(response);
        }, 2000);
    }

    useEffect(() => {
        loadUsers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingUsers]);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleConfirm = async () => {
        setOpen(false);
        try {
            const { data } = await reportsService.exportWalletTransactions(startDate, endDate, selectedUser);
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `transactions_${selectedUser}-${startDate}-${endDate}.xlsx`); // Nome do arquivo
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } catch (error) {
            console.error('Erro ao baixar o arquivo:', error);
            alert('Erro ao gerar o relatório.');
        }
    };

    const generateExcel = async () => {
        // seu código de exportação
    };

    return (
        <div className='reports-container'>
            <div className="debtors-ranking">
                <h1>Ranking de Devedores</h1>
                <Button variant="contained" onClick={handleOpen} sx={{ mr: 2 }}>
                    Selecionar Loja e Intervalo
                </Button>
                <Button variant="outlined" onClick={generateExcel}>
                    Exportar
                </Button>

                {/* Modal */}
                <Dialog open={open} onClose={handleClose}>
                    <DialogTitle>Selecionar Filtros</DialogTitle>
                    <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <TextField
                            select
                            label="Usuário"
                            value={selectedUser}
                            onChange={(e) => setSelectedUser(e.target.value)}
                            fullWidth
                        >
                            {users.map((user) => (
                                <MenuItem key={user._id} value={user._id}>
                                    {user.name}
                                </MenuItem>
                            ))}
                        </TextField>

                        <TextField
                            label="Data Inicial"
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />

                        <TextField
                            label="Data Final"
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancelar</Button>
                        <Button variant="contained" onClick={handleConfirm}>Confirmar</Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>
    );
}
